import { mapState, mapMutations } from "vuex";
import { conversion } from "@/tool";
import * as apis from "@/api";
import Award3 from "@/components/award3";

const placeholderAwardItem = () => ({
  rarity: 0,
  itempic: "",
  itemname: "银质",
  price: 50000,
  viewRate: 5,
});

export default {
  components: {
    "c-award": Award3,
  },
  data() {
    return {
      // 查询类型：1=最新 2=官方推荐 3=每日最热 4=七日最热 5=每月最热 6=我创建的箱子
      activeTab: "",
      listTypeTabs: [
        { label: "所有", value: "" },
        { label: "最新", value: 1 },
        // { label: "官方推荐", value: 2 },
        // { label: "每日最热", value: 3 },
        // { label: "七日最热", value: 4 },
        // { label: "每月最热", value: 5 },
        // { label: "我创建的箱子", value: 6 },
        { label: "对多人开", value: 7 },
      ],
      priceRangeValue: "all",
      priceSortValue: "default",
      sortRangeValue: "default",
      priceRangeList: [
        { label: "所有", value: "all", min: 0, max: 99999999 },
        { label: "0-1", value: "01", min: 0, max: 1 },
        { label: "2-19", value: "219", min: 2, max: 19 },
        { label: "20-49", value: "2049", min: 20, max: 49 },
        { label: "50-99", value: "5099", min: 50, max: 99 },
        { label: "100+", value: "100", min: 100, max: 999999 },
      ],
      priceSortList: [
        { label: "默认", value: "default" },
        { label: "价格降序", value: "desc" },
        { label: "价格升序", value: "asc" },
      ],
      sortRangeList: [
        { label: "默认", value: "default" },
        { label: "最新", value: "newest" },
        { label: "最热", value: "hot" },
      ],
      boxList: [],
      riskList: [
        { name: "L", value: "l", activeBg: "rgb(56, 199, 57)", riskSchedule: 12.5 },
        { name: "M", value: "m", activeBg: "rgb(247, 188, 59)", riskSchedule: 37.5 },
        { name: "H", value: "h", activeBg: "rgb(251, 126, 61)", riskSchedule: 61.5 },
        { name: "I", value: "i", activeBg: "rgb(255, 64, 64)", riskSchedule: 87.5 },
      ],
      placeholderCaseAwards: [],
      placeholderRecentDrops: [],
      bannerDetail: null,
      bannerLoading: false,
      shareModalVisible: false,
      listLoading: false,
      loadMoreLoading: false,
      listPage: 1,
      listPageSize: 20,
      listTotal: 0,
      // 简介编辑弹框
      bioEditModalVisible: false,
      bioEditValue: "",
      bioEditLoading: false,
      // 分成信息
      profitInfo: null,
      profitInfoLoading: false,
    };
  },
  filters: {
    conversion,
  },
  computed: {
    ...mapState(["user"]),
    memberIdFromRoute() {
      const q = this.$route && this.$route.query;
      if (!q) return "";
      const id = q.memberId != null ? q.memberId : q.id;
      return id != null && id !== "" ? String(id).trim() : "";
    },
    shareUrl() {
      const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
      const id = this.memberIdFromRoute;
      if (!id) return baseUrl ? `${baseUrl}/box/share` : "";
      return baseUrl ? `${baseUrl}/box/share?id=${encodeURIComponent(id)}` : "";
    },
    shareTitle() {
      const name = this.userProfile.nickname || "Ta";
      return `${name}邀请你来开他创建的箱子!`;
    },
    userProfile() {
      const info = this.bannerDetail;
      if (info) {
        return {
          avatar: info.avatar || "",
          nickname: info.nickname || "",
          uid: info.uid != null ? String(info.uid) : (info.id != null ? String(info.id) : ""),
          intro: info.bio || "",
          level: info.vipLevel,
        };
      }
      return {
        avatar: this.user.avatar || this.user.headImgUrl || "",
        nickname: this.user.nickname || this.user.userName || "",
        uid: this.user.uid || this.user.id || "",
        intro: this.user.intro || this.user.signature,
        level: this.user.level,
      };
    },
    userStats() {
      const info = this.bannerDetail;
      if (info) {
        return {
          createdCount: info.openCount != null ? info.openCount : (info.createdCount != null ? info.createdCount : 0),
          openedValue: info.totalProfit != null ? info.totalProfit : (info.spendAmount != null ? info.spendAmount : 0),
          totalEarnings: info.totalEarnings != null ? info.totalEarnings : (info.totalProfit != null ? info.totalProfit : 0),
          todayOpenedCount: info.todayOpenedCount != null ? info.todayOpenedCount : 0,
          todayOpenedValue: info.todayOpenedValue != null ? info.todayOpenedValue : 0,
          todayEarnings: info.todayEarnings != null ? info.todayEarnings : 0,
          earnings: info.earnings != null ? info.earnings : (info.totalEarnings != null ? info.totalEarnings : 0),
        };
      }
      return {
        createdCount: this.boxList.length,
        openedValue: 0,
        totalEarnings: 0,
        todayOpenedCount: 0,
        todayOpenedValue: 0,
        todayEarnings: 0,
        earnings: 0,
      };
    },
    displayEarnings() {
      // 使用 profitInfo 中的 pendingProfit（待领取收益）
      if (this.profitInfo && this.profitInfo.pendingProfit != null) {
        return this.profitInfo.pendingProfit;
      }
      return 0;
    },
    profitInfoStats() {
      // 返回分成信息的统计数据，用于显示在统计框中
      if (this.profitInfo) {
        return {
          totalCaseCount: this.profitInfo.totalCaseCount != null ? this.profitInfo.totalCaseCount : 0,
          totalOpenedValue: this.profitInfo.totalOpenedValue != null ? this.profitInfo.totalOpenedValue : 0,
          totalReceivedProfit: this.profitInfo.totalReceivedProfit != null ? this.profitInfo.totalReceivedProfit : 0,
          todayOpenCount: this.profitInfo.todayOpenCount != null ? this.profitInfo.todayOpenCount : 0,
          todayOpenedValue: this.profitInfo.todayOpenedValue != null ? this.profitInfo.todayOpenedValue : 0,
          todayProfit: this.profitInfo.todayProfit != null ? this.profitInfo.todayProfit : 0,
          pendingProfit: this.profitInfo.pendingProfit != null ? this.profitInfo.pendingProfit : 0,
        };
      }
      return {
        totalCaseCount: 0,
        totalOpenedValue: 0,
        totalReceivedProfit: 0,
        todayOpenCount: 0,
        todayOpenedValue: 0,
        todayProfit: 0,
        pendingProfit: 0,
      };
    },
    displayList() {
      let list = this.boxList || [];
      if (this.priceRangeValue && this.priceRangeValue !== "all") {
        const range = this.priceRangeList.find((r) => r.value === this.priceRangeValue);
        if (range && range.min != null) {
          list = list.filter((i) => i.price >= range.min && i.price <= range.max);
        }
      }
      if (this.priceSortValue === "desc") {
        list = [...list].sort((a, b) => (b.price || 0) - (a.price || 0));
      } else if (this.priceSortValue === "asc") {
        list = [...list].sort((a, b) => (a.price || 0) - (b.price || 0));
      }
      // if (list.length === 0 && this.boxList.length === 0) {
      //   return this._placeholderBoxList();
      // }
      return list;
    },
    hasMore() {
      return this.boxList.length < this.listTotal && !this.listLoading;
    },
    // 当前 Tab 即接口 type：1=最新 2=官方推荐 3=每日最热 4=七日最热 5=每月最热 6=我创建的箱子
    listType() {
      const t = this.activeTab;
      return t >= 1 && t <= 6 ? t : 1;
    },
  },
  watch: {
    activeTab() {
      if (this.memberIdFromRoute) {
        this.boxList = [];
        this.listTotal = 0
        this.loadMineList();
      }
    },
    memberIdFromRoute: {
      handler(memberId) {
        if (memberId) {
          this.loadBannerDetail(memberId);
          this.loadMineList();
        } else {
          this.bannerDetail = null;
          this.bannerLoading = false;
          this.boxList = [];
          this.listTotal = 0;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    if (this.memberIdFromRoute) {
      this.boxList = [];
      this.listTotal = 0;
      await this.loadMineList();
    }
    // 获取分成信息
    await this.loadProfitInfo();
  },
  methods: {
    ...mapMutations(["setInfo"]),
    // 获取分成信息
    async loadProfitInfo() {
      this.profitInfoLoading = true;
      try {
        const res = await apis.getProfitInfo();
        if (res && res.data && (res.data.code === 0 || res.data.success)) {
          this.profitInfo = res.data.data || null;
        } else {
          this.profitInfo = null;
        }
      } catch (error) {
        console.error("获取分成信息失败", error);
        this.profitInfo = null;
      } finally {
        this.profitInfoLoading = false;
      }
    },
    async loadBannerDetail(memberId) {
      if (!memberId || !apis.getUserCaseUserInfo) return;
      this.bannerLoading = true;
      this.bannerDetail = null;
      try {
        const res = await apis.getUserCaseUserInfo(memberId);
        if (res && res.data && (res.data.code === 0 || res.data.success) && res.data.data) {
          this.bannerDetail = res.data.data;
        }
      } catch (e) {
        console.warn("getUserCaseUserInfo error", e);
      } finally {
        this.bannerLoading = false;
      }
    },
    _placeholderBoxList() {
      return [
        {
          caseId: "placeholder-1",
          caseName: "超级无敌传奇",
          casePic: "",
          price: 99999,
          riskLevel: 1,
          rollMin: 500,
          rollMax: 10000,
          probability: 5,
          caseAwards: this.placeholderCaseAwards,
          recentDrops: this.placeholderRecentDrops,
        },
        {
          caseId: "placeholder-2",
          caseName: "超级无敌传奇",
          casePic: "",
          price: 99999,
          riskLevel: 1,
          rollMin: 500,
          rollMax: 10000,
          probability: 5,
          caseAwards: this.placeholderCaseAwards,
          recentDrops: this.placeholderRecentDrops,
        },
      ];
    },
    async loadMineList() {
      const memberId = this.memberIdFromRoute;
      if (!memberId || !apis.getUserCasesByMemberId) {
        this.boxList = [];
        this.listTotal = 0;
        return;
      }
      this.listLoading = true;
      this.listPage = 1;
      try {
        const res = await apis.getUserCasesByMemberId(memberId, { type: this.listType, page: 1, pageSize: this.listPageSize });
        if (res && res.data && (res.data.code === 0 || res.data.success) && res.data.data) {
          const data = res.data.data;
          const list = data.list || data.items || [];
          this.boxList = (list || []).map((item) => this._mapCaseItem(item));
          this.listTotal = data.total != null ? data.total : this.boxList.length;
        } else {
          this.boxList = [];
          this.listTotal = 0;
        }
      } catch (e) {
        console.warn("getUserCasesByMemberId error", e);
        this.boxList = [];
        this.listTotal = 0;
      } finally {
        this.listLoading = false;
      }
    },
    async loadMore() {
      const memberId = this.memberIdFromRoute;
      if (!memberId || !apis.getUserCasesByMemberId || this.loadMoreLoading || this.boxList.length >= this.listTotal) return;
      this.loadMoreLoading = true;
      const nextPage = this.listPage + 1;
      try {
        const res = await apis.getUserCasesByMemberId(memberId, { type: this.listType, page: nextPage, pageSize: this.listPageSize });
        if (res && res.data && (res.data.code === 0 || res.data.success) && res.data.data) {
          const data = res.data.data;
          const list = data.list || data.items || [];
          const mapped = (list || []).map((item) => this._mapCaseItem(item));
          this.boxList = this.boxList.concat(mapped);
          this.listPage = nextPage;
          this.listTotal = data.total != null ? data.total : this.boxList.length;
        }
      } catch (e) {
        console.warn("getUserCasesByMemberId loadMore error", e);
      } finally {
        this.loadMoreLoading = false;
      }
    },
    _mapCaseItem(item) {
      const mapAward = (a) =>
        a && typeof a === "object"
          ? {
            rarity: a.rarity != null ? a.rarity : 0,
            itempic: a.itemPic || a.itemImgUrl || a.picture || "",
            itemname: a.itemName || a.name || "银质",
            price: a.sellPrice != null ? a.sellPrice : 0,
            viewRate: a.viewRate != null ? a.viewRate : 0,
          }
          : null;
      const items = (item.items || []).map(mapAward).filter(Boolean);
      return {
        ...item,
        caseId: item.id != null ? item.id : item.caseId,
        caseName: item.name || item.caseName,
        casePic: item.caseImgUrl || item.casePic,
        price: item.price,
        riskLevel: item.riskLevel != null ? item.riskLevel : 0,
        createTime: item.createTime,
        openCount: item.openCount,
        caseAwards: items,
        recentDrops: item.recentDrops || item.recentDropsList || [],
      };
    },
    itemRiskLevel(item) {
      const idx = item.riskLevel != null ? Math.min(3, Math.max(0, item.riskLevel)) : 1;
      return this.riskList[idx] ? this.riskList[idx].value : "m";
    },
    itemRiskSchedule(item) {
      const idx = item.riskLevel != null ? Math.min(3, Math.max(0, item.riskLevel)) : 1;
      return this.riskList[idx] ? this.riskList[idx].riskSchedule : 37.5;
    },
    onShare() {
      this.shareModalVisible = true;
    },
    closeShareModal() {
      this.shareModalVisible = false;
    },
    async copyShareUrl() {
      const url = this.shareUrl;
      if (!url) return;
      let descText = "快来看看我的箱子~";
      if (this.$refs.shareDescP) {
        descText = this.$refs.shareDescP.innerText || this.$refs.shareDescP.textContent || descText;
      }
      const copyText = `${descText.trim()} ${url}`;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(copyText);
        } else {
          const input = document.createElement("input");
          input.value = copyText;
          input.readOnly = true;
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$toast && this.$toast.success("已复制网址");
      } catch (e) {
        this.$toast && this.$toast.fail("复制失败");
      }
    },
    async handleClaimEarnings() {
      // 检查是否有待领取收益
      if (!this.profitInfo || (this.profitInfo.pendingProfit == null || this.profitInfo.pendingProfit <= 0)) {
        this.$message && this.$message.warning("暂无待领取收益");
        return;
      }

      try {
        const res = await apis.withdrawProfit();

        if (res && res.data && res.data.code === 0) {
          // 提示成功
          this.$message && this.$message.success("收益领取成功");

          // 刷新分成信息
          await this.loadProfitInfo();

          // 调用 setInfo 更新用户信息
          this.setInfo();
        } else {
          const errorMsg = res?.data?.msg || "领取失败，请重试";
          this.$message && this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error("领取收益失败", error);
        this.$message && this.$message.error("领取失败，请重试");
      }
    },
    // 打开简介编辑弹框
    openBioEditModal() {
      this.bioEditValue = this.userProfile.intro || "";
      this.bioEditModalVisible = true;
    },
    // 关闭简介编辑弹框
    closeBioEditModal() {
      this.bioEditModalVisible = false;
      this.bioEditValue = "";
    },
    // 保存简介
    async saveBio() {
      if (this.bioEditLoading) return;

      this.bioEditLoading = true;
      try {
        const res = await apis.setBio({ val: this.bioEditValue });

        if (res && res.data && res.data.code === 0) {
          // 更新本地显示
          if (this.bannerDetail) {
            this.bannerDetail.bio = this.bioEditValue;
          }

          // 调用 setInfo 更新用户信息
          this.setInfo();

          // 提示成功
          this.$message && this.$message.success("简介更新成功");

          // 关闭弹框
          this.closeBioEditModal();
        } else {
          const errorMsg = res?.data?.msg || "保存失败，请重试";
          this.$message && this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error("保存简介失败", error);
        this.$message && this.$message.error("保存失败，请重试");
      } finally {
        this.bioEditLoading = false;
      }
    },
    goOpen(item) {
      if (!item.caseId && item.caseId !== 0) return;
      if (String(item.caseId).indexOf("placeholder") === 0) return;
      this.$router.push({
        name: "case",
        params: { id: item.caseId },
        query: { userCase: 1 }
      });
    },
    scrollAwardList(ev, direction) {
      const wrap = ev && ev.currentTarget && ev.currentTarget.closest && ev.currentTarget.closest(".mine-card-award-list-wrap");
      if (!wrap) return;
      const list = wrap.querySelector(".mine-card-award-list");
      if (!list) return;
      const step = 220;
      list.scrollBy({ left: direction * step, behavior: "smooth" });
    },
  },
};
